import { render, staticRenderFns } from "./TextReadGuide.vue?vue&type=template&id=4aadf2e8&scoped=true&"
import script from "./TextReadGuide.vue?vue&type=script&lang=js&"
export * from "./TextReadGuide.vue?vue&type=script&lang=js&"
import style0 from "./TextReadGuide.vue?vue&type=style&index=0&id=4aadf2e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aadf2e8",
  null
  
)

export default component.exports